import { T_LANGUAGE_CODES } from '~/src/Constants/LANGUAGE'

export interface I_LANGUAGE_STATE {
  selectedLanguage: T_LANGUAGE_CODES
}

export const INITIAL_STATE: I_LANGUAGE_STATE = {
  selectedLanguage: 'hu'
}
